import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Translate from 'translate';

import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import NetworkService from 'services/NetworkService';

class NetworksList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      logsData: [],
      deleteModalOpened: false,
    };

    this.deleteEntity = this.deleteEntity.bind( this );
    this.getData = this.getData.bind( this );
    this.toggleDeleteModal = this.toggleDeleteModal.bind( this );
  }

  deleteEntity() {
    this.props.toggleLoading( true );

    NetworkService.deleteNetwork( this.entityToDelete ).then( ( response ) => {
      if( response.errors ) {
        this.props.toggleLoading( false );
        return this.props.toggleAlertError( response.errors );
      }

      this.toggleDeleteModal();
      this.getData( this.params )
    } )
  }

  getData( params, cb ) {
    const { isLoading, toggleLoading } = this.props;
    this.params = params;

    if( !isLoading ) toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    apiParams[`filters[type]`] = 'email';
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';

    NetworkService.getNetworks( apiParams ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );
      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data || [],
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  }

  verifyEmail = ( id ) => {
    const { toggleLoading, toggleAlertError } = this.props;
    toggleAlertError( 'This will take some time' );
    toggleLoading( true );

    NetworkService.verifyNetwork( id ).then( ( response ) => {
      if( response.errors ) {
        toggleLoading( false );
        toggleAlertError( response.errors )
      } else {
        toggleAlertError( !response.data.status ? 'Account deactivated' : 'Correctly verified' );
        this.getData( this.params )
      }
    } )
  };

  toggleDeleteModal( entityId ) {
    this.entityToDelete = entityId;
    this.setState( { deleteModalOpened: !this.state.deleteModalOpened } )
  };

  reloadSocialNetwork = ( action ) => {
    const { toggleLoading, toggleAlertError } = this.props;
    toggleLoading( true );

    NetworkService.sendNetworkAction( 'email', action )
      .then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) {
          return toggleAlertError( response.errors )
        } else {
          return toggleAlertError( 'The operation completed successfully' );
        }
      } )
  };

  render() {
    const { ...rest } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header d-flex justify-content-between">
            <span className="text-capitalize"><Translate id="email"/></span>
            <Link to={`/configurations/email/new`}>
              <button className="btn btn-info">Add Account</button>
            </Link>
          </div>
          <div className="box-body">
            <AsyncTable className="app-table-white"
                        onFetchData={this.getData}
                        rowsText={<Translate id="entries"/>}
                        {...rest}
                        columns={[
                          { Header: <Translate id="email"/>, accessor: 'email' },
                          { Header: <Translate id="alias"/>, accessor: 'alias' },
                          { Header: <Translate id="status"/>, accessor: 'status', maxWidth: 120, },
                          {
                            Header: <Translate id="active"/>,
                            maxWidth: 80,
                            accessor: 'active', Cell: ( props ) =>
                              props.value ? <i className="fa fa-check"/> : <i className="fa fa-close"/>
                          },
                          {
                            Header: '', accessor: 'id',
                            maxWidth: 120,
                            Cell: props =>
                              <div>
                                <Link to={`/configurations/email/edit/${props.value}`}>
                                  <button className="btn btn-outline-info btn-sm mr-2">
                                    <i className="fa fa-edit"/>
                                  </button>
                                </Link>
                                <button className="btn btn-outline-danger btn-sm"
                                        onClick={() => this.toggleDeleteModal( props.value )}>
                                  <i className="fa fa-trash"/>
                                </button>
                                <button className="btn btn-outline-info btn-sm ml-2"
                                        onClick={() => this.verifyEmail( props.value )}>
                                  {!props.original.active
                                    ? <i className="fa fa-check"/> : <i className="fa fa-close"/>}
                                </button>
                              </div>
                          },
                        ]}/>
          </div>

          <DeleteModal onConfirm={this.deleteEntity}
                       opened={this.state.deleteModalOpened}
                       onToggle={this.toggleDeleteModal}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  isLoading: state.settings.isLoading
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( NetworksList );




// WEBPACK FOOTER //
// ./routes/app/routes/configuration/emails/dashboard/index.js